/**
 * @generated SignedSource<<7111b97f9a2114a46df2f41ad3a55bca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftHeartPillProvider_viewer$data = {
  readonly id: string;
  readonly isNftItemsLikedByUser?: ReadonlyArray<{
    readonly id: string;
    readonly isLiked: boolean | null;
    readonly nftId: string | null;
  } | null> | null;
  readonly " $fragmentType": "NftHeartPillProvider_viewer";
};
export type NftHeartPillProvider_viewer$key = {
  readonly " $data"?: NftHeartPillProvider_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer">;
};

import NftHeartPillProviderRefetchQuery_graphql from './NftHeartPillProviderRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": "[]",
      "kind": "LocalArgument",
      "name": "nftIds"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftHeartPillProviderRefetchQuery_graphql
    }
  },
  "name": "NftHeartPillProvider_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "nftIds",
              "variableName": "nftIds"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemUserLike",
          "kind": "LinkedField",
          "name": "isNftItemsLikedByUser",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nftId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLiked",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "21e43b463ba876673610972092877971";

export default node;
